// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2weQf","delete":"styles_delete__43Bb-","update":"styles_update__2e9ZZ","add":"styles_add__2xKZc"};